invHdApp.
factory('Plate', ['$http', function($http) {
    return {
      all: function() {
        return $http.get('api/plates');
      },
      get: function(id) {
        return $http.get('api/plate/' + id);
      },
      new: function(id) {
        return $http.get('api/new-plate');
      },
      delete: function(id) {
        return $http.delete('api/delete-plate/' + id);
      },
      save: function(data) {
        return $http.post('api/save-plate',data);
      },
      update: function(data) {
        return $http.post('api/update-plate',data);
      }
    };
}]);